module.exports = __webpack_public_path__ + "New-9c124766.png";